"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var InputCombobox_styled_exports = {};
__export(InputCombobox_styled_exports, {
  StyledComboboxContainer: () => StyledComboboxContainer,
  StyledErrorContainer: () => StyledErrorContainer,
  StyledIcon: () => StyledIcon,
  StyledInput: () => StyledInput,
  StyledInputLayout: () => StyledInputLayout,
  StyledLabel: () => StyledLabel,
  StyledSearchContainer: () => StyledSearchContainer
});
module.exports = __toCommonJS(InputCombobox_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_atoms = require("../../atoms");
var import_mixins = require("../../../themes/mixins");
var StyledComboboxContainer = import_styled_components.default.div.withConfig({
  displayName: "InputComboboxstyled__StyledComboboxContainer",
  componentId: "sc-1yy3e02-0"
})(function(_ref) {
  var theme = _ref.theme;
  return (0, import_styled_components.css)(["cursor:pointer;font-family:", ";max-width:400px;min-width:130px;padding:", ";margin:", ";position:relative;.select__option{white-space:normal;}"], theme.typography.fonts.primary, theme.measurements.zero, theme.measurements.zero);
});
var StyledSearchContainer = import_styled_components.default.div.withConfig({
  displayName: "InputComboboxstyled__StyledSearchContainer",
  componentId: "sc-1yy3e02-1"
})(function(_ref2) {
  var theme = _ref2.theme, darkMode = _ref2.darkMode, isDisabled = _ref2.isDisabled, error = _ref2.error, borderLess = _ref2.borderLess;
  return (0, import_styled_components.css)(["display:flex;align-items:center;box-sizing:border-box;background-color:", ";height:56px;padding:6px 14px 6px 12px;", ";", ";&:hover{", ";}&:focus,&:focus-visible,&:focus-within{outline:none;box-shadow:0 0 0 2px ", ";}&:active{outline:none;", ";}"], theme.colors.white, (0, import_mixins.comboBoxStyles)({
    theme,
    darkMode,
    isDisabled,
    error,
    borderLess
  }), (0, import_mixins.withBorderRadius)(theme.measurements.small), !isDisabled && !error && (0, import_styled_components.css)(["box-shadow:0 0 0 2px ", ";"], darkMode ? theme.colors.beige[140] : theme.colors.beige[180]), darkMode ? theme.colors.white : theme.colors.n[100], !isDisabled && (0, import_styled_components.css)(["box-shadow:0 0 0 2px ", ";"], darkMode ? theme.colors.white : theme.colors.n[100]));
});
var StyledInputLayout = import_styled_components.default.div.withConfig({
  displayName: "InputComboboxstyled__StyledInputLayout",
  componentId: "sc-1yy3e02-2"
})(function(_ref3) {
  var active = _ref3.active;
  return (0, import_styled_components.css)(["flex-grow:1;overflow:hidden;height:100%;position:relative;", ""], active && (0, import_styled_components.css)(["label{top:0;}"]));
});
var StyledLabel = import_styled_components.default.label.withConfig({
  displayName: "InputComboboxstyled__StyledLabel",
  componentId: "sc-1yy3e02-3"
})(function(_ref4) {
  var theme = _ref4.theme;
  return (0, import_styled_components.css)(["text-align:left;font-size:", ";line-height:", ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;position:absolute;top:calc(100% - 30px);left:5px;text-transform:capitalize;width:100%;cursor:inherit;"], theme.typography.sizes.small, theme.measurements.extraExtraLarge);
});
var StyledInput = import_styled_components.default.input.withConfig({
  displayName: "InputComboboxstyled__StyledInput",
  componentId: "sc-1yy3e02-4"
})(["background-color:transparent;border:none;color:inherit;font-size:16px;height:90%;outline:0;padding:7px 0 0 5px;width:98%;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;cursor:inherit;"]);
var StyledErrorContainer = import_styled_components.default.div.withConfig({
  displayName: "InputComboboxstyled__StyledErrorContainer",
  componentId: "sc-1yy3e02-5"
})(function(_ref5) {
  var theme = _ref5.theme, darkMode = _ref5.darkMode;
  return (0, import_styled_components.css)(["display:flex;align-items:flex-start;color:", ";font-size:", ";line-height:", ";margin-top:", ";position:absolute;top:100%;cursor:text;"], darkMode ? theme.colors.status.error[20] : theme.colors.status.error[100], theme.typography.textStyles.textSmall, theme.measurements.extraExtraLarge, theme.measurements.extraSmall);
});
var StyledIcon = (0, import_styled_components.default)(import_atoms.Icon).withConfig({
  displayName: "InputComboboxstyled__StyledIcon",
  componentId: "sc-1yy3e02-6"
})(function(_ref6) {
  var theme = _ref6.theme;
  return (0, import_styled_components.css)(["font-size:", ";line-height:", ";margin-right:", ";cursor:default;"], theme.iconology.sizes.small, theme.measurements.extraExtraLarge, theme.measurements.small);
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledComboboxContainer,
  StyledErrorContainer,
  StyledIcon,
  StyledInput,
  StyledInputLayout,
  StyledLabel,
  StyledSearchContainer
});
//# sourceMappingURL=InputCombobox.styled.js.map